<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row mb-2">
        <div class="col-xs-12 col-sm-8 text-center mb-2">
            <div class="card h-100">
              <div class="card-body">
                <div class="row mt-5 mb-5 mx-auto" v-if="loading">
                  <div class="col-12 p-5 m-4 text-center">
                      <div class="spinner-border text-secondary" role="status" v-if="loading">
                          <span class="sr-only">Loading..</span>
                        </div>
                  </div>
                </div>
                <div v-if="!loading">
                  <h5 class="card-title mb-2 mt-2"><b>{{$t("log.top-call-out")}}</b></h5>
                    <apexchart
                      class="apex-charts"
                      dir="ltr"
                      height="700"
                      :series="call_out_count"
                      :options="categoryOptions.chartOptions" 
                    ></apexchart>
                </div>
              </div>
            </div>
        </div>
        <div class="col-xs-12 col-sm-4 text-center mb-2">
          <div class="card h-100">
            <div class="card-body">
                <div class="row mt-5 mb-5 mx-auto" v-if="loading">
                  <div class="col-12 p-5 m-4 text-center">
                      <div class="spinner-border text-secondary" role="status" v-if="loading">
                          <span class="sr-only">Loading..</span>
                        </div>
                  </div>
                </div>
               <div v-if="!loading">
                  <h5 class="card-title py-2 text-left"><b>{{$t("log.top-call-out")}}</b></h5>
                    <table class="table table-bordered">
                      <thead>
                        <th width="10%">No</th>
                        <th  class="text-left">{{$t("user-management.name")}}</th>
                        <th width="30%">Total</th>
                      </thead>
                      <tbody>
                        <tr v-for="(data, index) in tableData.slice(0,10)" :key="data.gid">
                          <td>{{index+1}}</td>
                          <td class="text-left">
                            {{data.address}} <br>
                            <span v-if="data.profile">({{data.profile.name}})</span>
                            <span v-else>(-)</span>
                            </td>
                          <td>{{data.call_out_count}}</td>
                        </tr>
                      </tbody>
              </table>
              </div>
            </div>
          </div>
        </div>
    </div> 

    <div class="row mb-4">
        <div class="col-xs-12 col-sm-8 text-center mb-2">
            <div class="card h-100">
              <div class="card-body">
                <div class="row mt-5 mb-5 mx-auto" v-if="loading">
                  <div class="col-12 p-5 m-4 text-center">
                      <div class="spinner-border text-secondary" role="status" v-if="loading">
                          <span class="sr-only">Loading..</span>
                        </div>
                  </div>
                </div>
                <div v-if="!loading">
                  <h5 class="card-title mb-2 mt-2"><b>{{$t("log.top-receive-call")}}</b></h5>
                    <apexchart
                      class="apex-charts"
                      dir="ltr"
                      height="700"
                      :series="call_in_count"
                      :options="categoryOptionsCall.chartOptions" 
                    ></apexchart>
                </div>
              </div>
            </div>
        </div>
        <div class="col-xs-12 col-sm-4 text-center mb-2">
          <div class="card h-100">
            <div class="card-body">
                <div class="row mt-5 mb-5 mx-auto" v-if="loading">
                  <div class="col-12 p-5 m-4 text-center">
                      <div class="spinner-border text-secondary" role="status" v-if="loading">
                          <span class="sr-only">Loading..</span>
                        </div>
                  </div>
                </div>
               <div v-if="!loading">
                  <h5 class="card-title py-2 text-left"><b>{{$t("log.top-receive-call")}}</b></h5>
                    <table class="table table-bordered">
                      <thead>
                        <th width="10%">No</th>
                        <th  class="text-left">{{$t("user-management.name")}}</th>
                        <th width="30%">Total</th>
                      </thead>
                      <tbody>
                        <tr v-for="(data, index) in tableDataCall.slice(0,10)" :key="data.gid">
                          <td>{{index+1}}</td>
                          <td class="text-left">
                            {{data.address}} <br>
                            <span v-if="data.profile">({{data.profile.name}})</span>
                            <span v-else>(-)</span>
                            </td>
                          <td>{{data.call_in_count}}</td>
                        </tr>
                      </tbody>
              </table>
              </div>
            </div>
          </div>
        </div>
    </div> 
  </Layout>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import grupService from "@/helpers/grup.service";
import UserService from "@/helpers/user.service";
import { required, email, sameAs } from "vuelidate/lib/validators";
import StatistikService from "@/helpers/statistik.service";
import store from '@/state/store';
import moment from "moment";
import { tableData } from '../applications/dataAdvancedtable';

export default {
  page: {
    title: "Grup Management",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
      let categoryOptions = {
        chartOptions: {
            chart: {
                type: 'pie',
            },
            labels: [],
            colors: ['#ea580c','#059669', '#34d399','#e11d48','#2563eb', '#eab308','#475569','#94a3b8', '#84cc16', '#60a5fa','#0891b2', '#e879f9'],
            legend: {
                show: true,
                position: 'bottom',
                labels: {
                colors: '#74788d',
            },
            }, 
          }
      };

      let categoryOptionsCall = {
        chartOptions: {
            chart: {
                type: 'pie',
            },
            labels: [],
            colors: ['#ea580c','#059669', '#34d399','#e11d48','#2563eb', '#eab308','#475569','#94a3b8', '#84cc16', '#60a5fa','#0891b2', '#e879f9'],
            legend: {
                show: true,
                position: 'bottom',
                labels: {
                colors: '#74788d',
            },
            }, 
          }
      };

    return {
      categoryOptionsCall,
      categoryOptions,
      total_call_group:0,
      total_members_group:0,
      total_group:0,
      x_cat:[],
      call_in_count:[],
      call_out_count:[],
      options: [],
      tableData:[],
      tableDataCall:[],
      top_group:[],
      title: this.$t("log.log-call-grafik"),
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: this.$t("log.log-call"),
          href: "/log-call",
        },
        {
          text: this.$t("log.log-call-grafik"),
          active: true
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      form: {
        grup: {
          "name": ""
        }
      },
      loading:false,
      loading_message: false,
      submitted: false,
      loading_add: false,
      fields: [
        { key: "profile", sortable: true, label: this.$t("group-management.member-name") },
        { key: "address", sortable: true, label: this.$t("group-management.address") },
        { key: "lastonline", sortable: true, label: this.$t("group-management.member-lastonline") },
        { key: "online", sortable: true, label: "Status" },
        { key: "action", sortable: true , thStyle:{width: '10%'},  class: 'text-center', label: this.$t("tables.action")}
      ],
    };
  },
  validations: {
    form: {
      grup: {
        name: { required }
      },
    },
  },

  computed: {
  rows() {
    return this.tableData.length;
  },
  sortedArray() {
    function compare(b, a) {
      if (a.call_out_count < b.call_out_count)
        return -1;
      if (a.call_out_count > b.call_out_count)
        return 1;
      return 0;
    }
    return this.tableData.sort(compare);
  },
  },
  beforeMount(){
      // this.totalCallUser();
      this.getUser();
  },
  mounted() {
    // Set the initial number of items
    // this.totalGroup();
    // this.totalMembers();
    this.totalRows = this.items.length;
    this.availableOptions;

  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    onOptionClick(option) {
      this.relation.push({
        address: option.address,
        profile: option.profile
      });
      this.show = false;
      this.search = "";
    },

    getUser(){
      this.loading = true;
      UserService.listUser()
        .then((response) => {
          // this.tableData = response.data.data;
          // this.tableDatacall = response.data.data;
          console.log( response.data.data);
          response.data.data.forEach(val => {
          if(val.call_out_count !== 0){
            const data = {
                    "uid": val.uid,
                    "appid": val.appid,
                    "address": val.address,
                    "logins": val.logins,
                    "ipaddr":val.ipaddr,
                    "lastonline": val.lastonline,
                    "flag": val.flag,
                    "active": val.active,
                    "online": val.online,
                    "pinned": val.pinned,
                    "call_in_count": val.call_in_count,
                    "call_out_count": val.call_out_count,
                    "call_in_count": val.call_in_count,
                    "call_out_count": val.call_out_count,
                    "profile": val.profile
            }
            this.tableData.push(data);
            if(val.profile){
               this.categoryOptions.chartOptions.labels.push(val.profile.name);
            }else{
               this.categoryOptions.chartOptions.labels.push(val.address);
            }
            this.call_out_count.push(val.call_out_count);
          }
          

         if(val.call_in_count !== 0){
            const data = {
                    "uid": val.uid,
                    "appid": val.appid,
                    "address": val.address,
                    "logins": val.logins,
                    "ipaddr":val.ipaddr,
                    "lastonline": val.lastonline,
                    "flag": val.flag,
                    "active": val.active,
                    "online": val.online,
                    "pinned": val.pinned,
                    "call_in_count": val.call_in_count,
                    "call_out_count": val.call_out_count,
                    "call_in_count": val.call_in_count,
                    "call_out_count": val.call_out_count,
                    "profile": val.profile
            }
            this.tableDataCall.push(data);
            if(val.profile){
               this.categoryOptionsCall.chartOptions.labels.push(val.profile.name);
            }else{
               this.categoryOptionsCall.chartOptions.labels.push(val.address);
            }
            this.call_in_count.push(val.call_in_count);
          }
          });
          
          this.sortedArraycall();
          this.sortedArray();
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          // console.log(err);
        });
    },

    // totalCallUser() {
    //   StatistikService.gettotalCallUser()
    //     .then((response) => {
    //       this.total_call_group = response.data.data;
    //       this.loading = false;
    //     })
    //     .catch((err) => {
    //       this.loading = false;
    //       // console.log(err);
    //     });
    // },

    sortedArraycall() {
      function compare(b, a) {
        if (a.call_in_count < b.call_in_count)
          return -1;
        if (a.call_in_count > b.call_in_count)
          return 1;
        return 0;
      }
      return this.tableDataCall.sort(compare);
    },

    formatDate(value) {
      return moment(value).format("YYYY-MM-DD, HH:mm");
    },

    formatDateTimes(value) {
        var unixTime	= value;
        var momentDate	= moment.unix(unixTime),
        momentDay		=	momentDate.format('DD'),
        momentMonth		=	momentDate.format('MM'),
        momentYear		=	momentDate.format('YYYY'),
        momentHours		=	momentDate.format('HH'),
        momentMinutes	=	momentDate.format('mm'),
        momentSeconds	=	momentDate.format('ss');
        // let time = momentYear+'-'+momentMonth+'-'+momentDay+' '+momentHours+':'+momentMinutes+':'+momentSeconds;

        var t = '"'+momentYear+'-'+momentMonth+'-'+momentDay+' '+momentHours+':'+momentMinutes+'"';
        var cdt = moment(t, 'YYYY-MM-DD HH:mm');
        let a = this.formatDate(cdt);
        return a;
    },
  },
  
};
</script>